import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function GroupAdd(props:any) {
  return (
    <SvgIcon {...props}>
      <path d="M16 11c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 3-1.34 3-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C13 14.17 8.33 13 6 13zm10 2v2h4v-2h-4z" />
    </SvgIcon>
  )
}
